module.exports = __webpack_public_path__ + "static/media/8.33f364f9.jpeg";